import { render, staticRenderFns } from "./LandBase.vue?vue&type=template&id=46d11265&scoped=true&"
import script from "./LandBase.vue?vue&type=script&lang=js&"
export * from "./LandBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d11265",
  null
  
)

export default component.exports